import { render, staticRenderFns } from "./ProjectsTablePagination.vue?vue&type=template&id=06c867bc&scoped=true&"
import script from "./ProjectsTablePagination.vue?vue&type=script&lang=js&"
export * from "./ProjectsTablePagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c867bc",
  null
  
)

export default component.exports